import { getList } from './action'
import { useRequest } from 'utils/useRequest'

export const useList = () => {
  return useRequest<any[]>(getList)
}
